import api from './axios';
/**
 * Télécharge un fichier de l'API via axios : les intercepteurs portent le JWT
 * et le header X-Commune-Slug, indispensable sous impersonation super admin.
 * Le nom du fichier vient du Content-Disposition renvoyé par le serveur.
 */
export async function downloadFile(url, fallbackName, params) {
    const { data, headers } = await api.get(url, { params, responseType: 'blob' });
    const disposition = String(headers['content-disposition'] ?? '');
    const match = /filename="?([^";]+)"?/.exec(disposition);
    const objectUrl = URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = match?.[1] ?? fallbackName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
}
